import { render, staticRenderFns } from "./OrganIndex.vue?vue&type=template&id=ba002b9c&"
import script from "./OrganIndex.vue?vue&type=script&lang=js&"
export * from "./OrganIndex.vue?vue&type=script&lang=js&"
import style0 from "./OrganIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports